export const FLOVATAR_CREATED = "A.921ea449dffec68a.Flovatar.Created"
export const FLOVATAR_UPDATED = "A.921ea449dffec68a.Flovatar.Updated"